import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikValues } from 'formik/dist/types';

import { useTrainingActivityTypePicker } from '../../../hooks/use-training-activity-type-picker';
import AppFormSelectWrapper from '../../designe/forms/app-form-select-wrapper';

export interface ITrainingActivityTypePickerProps {
  formik: FormikValues;
  name?: string;
  disabled?: boolean;
  className?: string;
  fullWidth?: boolean;
}

const TrainingActivityTypePicker: React.FC<
  ITrainingActivityTypePickerProps
> = ({
  formik,
  name = 'activityTypeId',
  disabled = false,
  className,
  fullWidth,
}) => {
  const { t } = useTranslation();
  const { activityTypes, isPickerDisabled, isError } =
    useTrainingActivityTypePicker();
  const selectedActivityTypeId = formik.values[name];

  const selectedActivityType = useMemo(
    () => activityTypes.find((type) => type.id === selectedActivityTypeId),
    [activityTypes, selectedActivityTypeId],
  );

  return (
    <AppFormSelectWrapper
      label={t('trainings.activityType')}
      name={name}
      formik={formik}
      options={activityTypes}
      fieldName="name"
      disableClear
      disableSearch
      disableSorting
      className={className}
      fullWidth={fullWidth}
      disabled={disabled || isPickerDisabled}
      explainingText={
        isError ? t('trainings.activityTypesLoadError') : undefined
      }
      defaultValue={selectedActivityType}
      onChange={(event) =>
        formik.setFieldValue(name, event?.target?.value?.id ?? null)
      }
    />
  );
};

export default TrainingActivityTypePicker;
